import { formatDistanceToNow } from "date-fns"
import { pl } from "date-fns/locale"
import { withPrefix } from "gatsby"
import React from "react"
import BackgroundImage from "gatsby-background-image";

export default ({ posts }) => (
  <section className="section wrapper">
    <div className="row expanded collapse show-for-large">
      <div className="large-6 medium-12 small-12 columns">
        <a href={posts[0].frontmatter.slug} className="white">
          <article className="news-large">
            <div className="display-table">
              <div className="display-table-cell v-bottom">
                <h2
                  className="margin-bottom10 white"
                  dangerouslySetInnerHTML={{
                    __html: posts[0].frontmatter.title,
                  }}
                />
                <div className="meta white">
                  <i className="fa fa-clock-o" />{" "}
                  {formatDistanceToNow(new Date(posts[0].frontmatter.date), {
                    locale: pl,
                  })}
                </div>
              </div>
            </div>
            <BackgroundImage
              Tag="div"
              className={"image"}
              fluid={posts[0].fields.thumbnail.childImageSharp.fluid}
              style={{position: 'absolute'}}
            />
          </article>
        </a>
      </div>
      <div className="large-6 medium-12 small-12 columns">
        <div className="row expanded collapse">
          <div className="large-12 medium-12 small-12 columns">
            <a href={posts[1].frontmatter.slug} className="white">
              <article className="news-medium">
                <div className="display-table">
                  <div className="display-table-cell v-bottom">
                    <h2
                      className="margin-bottom10 white"
                      dangerouslySetInnerHTML={{
                        __html: posts[1].frontmatter.title,
                      }}
                    />
                    <div className="meta white">
                      <i className="fa fa-clock-o" />{" "}
                      {formatDistanceToNow(
                        new Date(posts[1].frontmatter.date),
                        { locale: pl }
                      )}
                    </div>
                  </div>
                </div>
                <BackgroundImage
                  Tag="div"
                  className={"image"}
                  fluid={posts[1].fields.thumbnail.childImageSharp.fluid}
                  style={{position: 'absolute'}}
                />
              </article>
            </a>
          </div>
          <div className="large-6 medium-12 small-12 columns">
            <a href={posts[2].frontmatter.slug} className="white">
              <article className="news-medium margin-bottom0">
                <div className="display-table">
                  <div className="display-table-cell v-bottom">
                    <h2
                      className="margin-bottom10 white"
                      dangerouslySetInnerHTML={{
                        __html: posts[2].frontmatter.title,
                      }}
                    />
                    <div className="meta white">
                      <i className="fa fa-clock-o" />
                      {formatDistanceToNow(
                        new Date(posts[2].frontmatter.date),
                        { locale: pl }
                      )}
                    </div>
                  </div>
                </div>
                <BackgroundImage
                  Tag="div"
                  className={"image"}
                  fluid={posts[2].fields.thumbnail.childImageSharp.fluid}
                  style={{position: 'absolute'}}
                />
              </article>
            </a>
          </div>
          <div className="large-6 medium-12 small-12 columns">
            <a href={posts[3].frontmatter.slug} className="white">
              <article className="news-medium margin-bottom0">
                <div className="display-table">
                  <div className="display-table-cell v-bottom">
                    <h2
                      className="margin-bottom10 white"
                      dangerouslySetInnerHTML={{
                        __html: posts[3].frontmatter.title,
                      }}
                    />
                    <div className="meta white">
                      <i className="fa fa-clock-o" />
                      {formatDistanceToNow(
                        new Date(posts[3].frontmatter.date),
                        { locale: pl }
                      )}
                    </div>
                  </div>
                </div>
                <BackgroundImage
                  Tag="div"
                  className={"image"}
                  fluid={posts[3].fields.thumbnail.childImageSharp.fluid}
                  style={{position: 'absolute'}}
                />
              </article>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
)
